import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import {
  AccordionDetails, AccordionSummary,
  Divider, Typography,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { TerminationFees } from '../../../../Contexts/FreeResiliationFormulaContext/types';
import StyledAccordion from '../styles';

export default function ContractBreachResults(props: { terminationFees: TerminationFees, expanded: boolean, expand: () => void }) {
  const { terminationFees, expanded, expand } = props;
  const { i18n, t } = useTranslation('wysiwyg');
  const signedCurrencyFormat = new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'EUR', signDisplay: 'always' });
  const currencyFormat = new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'EUR' });
  const percentFormat = new Intl.NumberFormat(i18n.language, { style: 'percent', maximumFractionDigits: 0 });

  return (
    <StyledAccordion elevation={0} expanded={expanded} onChange={() => { expand(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <div className="step-number" data-step-number={2} />
        <Trans
          t={t}
          values={{ total: currencyFormat.format((terminationFees.amountAfterReimbursement ?? terminationFees.amountToPay)) }}
          components={{ 1: <strong /> }}
          i18nKey="resiliation-fee.results.fees.total"
        />
      </AccordionSummary>
      <AccordionDetails>
        {terminationFees.firstYear && (
          <Typography variant="body2">
            <Trans
              t={t}
              values={{ total: signedCurrencyFormat.format(terminationFees.firstYear.total), count: terminationFees.firstYear.months, monthly: currencyFormat.format(terminationFees.firstYear.monthly) }}
              components={{ 1: <strong /> }}
              i18nKey="resiliation-fee.results.fees.first-year"
            />
          </Typography>
        )}
        {terminationFees.secondYear && (
          <Typography variant="body2">
            <Trans
              t={t}
              values={{
                total: signedCurrencyFormat.format(terminationFees.secondYear.total),
                count: terminationFees.secondYear.months,
                monthly: currencyFormat.format(terminationFees.secondYear.monthly),
                ratio: percentFormat.format(terminationFees.secondYear.ratio),
              }}
              components={{ 1: <strong /> }}
              i18nKey="resiliation-fee.results.fees.second-year"
            />
          </Typography>
        )}
        {terminationFees.boxTerminationFee && (
          <Typography variant="body2">
            <Trans
              t={t}
              values={{ total: signedCurrencyFormat.format(terminationFees.boxTerminationFee) }}
              components={{ 1: <strong /> }}
              i18nKey="resiliation-fee.results.fees.box-fee"
            />
          </Typography>
        )}
        <Divider />
        <Typography variant="body2">
          <Trans
            t={t}
            values={{ total: currencyFormat.format(terminationFees.amountToPay) }}
            components={{ 1: <strong /> }}
            i18nKey="resiliation-fee.results.fees.amount-to-pay"
          />
        </Typography>
        {terminationFees.reimbursement && (
          <Typography variant="body2">
            <Trans
              t={t}
              values={{ total: signedCurrencyFormat.format(-terminationFees.reimbursement) }}
              components={{ 1: <strong /> }}
              i18nKey="resiliation-fee.results.fees.reimbursement"
            />
          </Typography>
        )}
        {terminationFees.amountAfterReimbursement !== undefined && (
          <Typography variant="body2">
            <Trans
              t={t}
              values={{ total: currencyFormat.format(terminationFees.amountAfterReimbursement) }}
              components={{ 1: <strong /> }}
              i18nKey="resiliation-fee.results.fees.amount-after-reimbursement"
            />
          </Typography>
        )}
        {terminationFees.law && (
          <Typography variant="caption" component="p">
            {terminationFees.law}
          </Typography>
        )}
      </AccordionDetails>
    </StyledAccordion>
  );
}
